import React, { useEffect, useRef, useState } from 'react';

const Splitter = (props: any) => {
  const { setSearchBoxStyle, inputValue } = props
  const vSplitterRef = useRef<HTMLDivElement>(null)
  const hSplitterRef = useRef<HTMLDivElement>(null)
  const [searchBoxWidth, setSearchBoxWidth] = useState(410)
  const [searchBoxHeight, setSearchBoxHeight] = useState(189)
  const searchBox = document.getElementsByClassName('dtd-db-search-page-wrap')?.[0]
  const offsetLeft = searchBox?.offsetLeft || 20
  const offsetTop = searchBox?.offsetTop || 214

  // 横向拖拽
  useEffect(() => {
    const $vertical = vSplitterRef.current;
    if ($vertical) {
      //鼠标移动
      let dragFlag = false;
      let tmpWidth = 0;
      const handleMouseMove = (e: MouseEvent) => {
        if (!dragFlag) {
          return;
        }
        tmpWidth = e.clientX;
        if (tmpWidth < 410) {
          tmpWidth = 410
          // css样式max-width限制
        } else if (tmpWidth > 600) {
          tmpWidth = 600
        }
        setSearchBoxWidth(tmpWidth)
      }

      // 鼠标松开
      const handleMouseUp = (e: MouseEvent) => {
        if (!dragFlag) {
          return;
        }
        dragFlag = false;
        const resizeEvent = new Event('resize');
        window.dispatchEvent(resizeEvent);
      }

      //鼠标按下
      const handleMouseDown = (e: MouseEvent) => {
        dragFlag = true;
      }
      $vertical.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);

      return () => {
        $vertical.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      }
    }
  }, [])

  // 纵向拖拽
  useEffect(() => {
    const $horizontal = hSplitterRef.current;
    if ($horizontal) {
      //鼠标移动
      let dragFlag = false;
      let tmpHeight = 0;
      const handleMouseMove = (e: MouseEvent) => {
        if (!dragFlag) {
          return;
        }
        tmpHeight = e.clientY - offsetTop;
        if (tmpHeight < 189) {
          tmpHeight = 189
          // 虚拟列表生成dom的最大高度
        } else if (tmpHeight > 270) {
          tmpHeight = 270
        }
        setSearchBoxHeight(tmpHeight)
      }

      // 鼠标松开
      const handleMouseUp = (e: MouseEvent) => {
        if (!dragFlag) {
          return;
        }
        dragFlag = false;
        const resizeEvent = new Event('resize');
        window.dispatchEvent(resizeEvent);
      }

      //鼠标按下
      const handleMouseDown = (e: MouseEvent) => {
        dragFlag = true;
      }
      $horizontal.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);

      return () => {
        $horizontal.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      }
    }
  }, [])

  useEffect(() => {
    const searchBoxContent = document.getElementsByClassName('dtd-db-search-page')?.[0]?.childNodes?.[0]
    if (searchBoxContent) searchBoxContent.style.height = '100%'
    setSearchBoxStyle({ width: searchBoxWidth, height: searchBoxHeight })
  }, [searchBoxWidth, searchBoxHeight, inputValue])

  return (<>
    <div className='dbd-splitter-vertical' ref={vSplitterRef} style={{ height: searchBoxHeight, top: offsetTop, left: offsetLeft + searchBoxWidth }}></div>
    <div className='dbd-splitter-horizontal' ref={hSplitterRef} style={{ width: searchBoxWidth, top: offsetTop + searchBoxHeight, left: offsetLeft }}></div>
  </>)
}

export default Splitter